<template>
  <div class="flex justify-between flex-wrap-">
    <div
      class="flex justify-start overflow-y-auto items-center text-sm text-center"
    >
      <div
        v-if="links.prev !== null"
        @click="paginate(currentPage - 1)"
        class="py-1 hover:bg-gray-100 rounded cursor-pointer border border-transparent hover:border-action w-6"
      >
        <font-awesome-icon icon="chevron-left"></font-awesome-icon>
      </div>
      <div class="w-6" v-else></div>

      <div
        v-if="leftEllipsis"
        class="py-1 px-2 min-w-10"
        :class="pageClass(1)"
        @click="paginate(1)"
        v-text="1"
      />
      <div v-if="leftEllipsis" class="py-1 px-2 min-w-10">...</div>

      <div
        class="py-1 px-2 min-w-10"
        v-for="page in length"
        :key="offset + page"
        :class="pageClass(offset + page)"
        @click="paginate(offset + page)"
        v-text="offset + page"
      />
      <div v-if="rightEllipsis" class="py-1 px-2 min-w-10">...</div>
      <div
        v-if="rightEllipsis"
        class="py-1 px-2 min-w-10"
        :class="pageClass(lastPage)"
        @click="paginate(lastPage)"
        v-text="lastPage"
      />

      <div
        @click="paginate(currentPage + 1)"
        v-if="links.next !== null"
        class="py-1 hover:bg-gray-100 rounded cursor-pointer border border-transparent hover:border-action w-6"
      >
        <font-awesome-icon icon="chevron-right"></font-awesome-icon>
      </div>
      <div class="w-6" v-else></div>
    </div>
    <div
      v-if="pluralName && meta.total > 1"
      class="text-sm text-gray-800 text-right"
    >
      <div>{{ meta.total }} {{ pluralName }}</div>
      <select class="py-0 pr-6 text-xs" :value="meta.per_page" @input="perPage">
        <option v-for="n in [6, 12, 25, 50]" :key="n" :value="n">
          {{ n }} {{ pluralName }} / page
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  props: ["links", "meta", "limit", "pluralName"],
  methods: {
    paginate(page) {
      this.$emit("page-changed", page);
    },

    pageClass(page) {
      return page === this.currentPage
        ? "font-bold border-b-2 border-action text-black"
        : "hover:text-black hover:bg-gray-100 rounded cursor-pointer border border-transparent hover:border-action";
    },
    perPage($event) {
      const n = $event.target.value;
      this.$emit("perpage-changed", n);
    },
  },
  computed: {
    currentPage() {
      return this.meta.current_page;
    },

    lastPage() {
      return this.meta.last_page;
    },

    maxWidth() {
      return Math.min(2 * (this.limit + 2) + 1, this.lastPage);
    },
    hasEllipsis() {
      return this.lastPage > this.maxWidth;
    },
    leftEllipsis() {
      return this.hasEllipsis && this.currentPage > this.limit + 3;
    },
    rightEllipsis() {
      return (
        this.hasEllipsis && this.currentPage <= this.lastPage - (this.limit + 3)
      );
    },
    offset() {
      if (!this.leftEllipsis) {
        return 0;
      }
      if (!this.rightEllipsis) {
        return this.lastPage - this.length;
      }
      return this.currentPage - this.limit - 1;
    },
    length() {
      let l = this.maxWidth;
      if (this.leftEllipsis) {
        l -= 2;
      }
      if (this.rightEllipsis) {
        l -= 2;
      }
      return l;
    },
    sum() {
      let s = this.length;
      if (this.leftEllipsis) {
        s += 2;
      }
      if (this.rightEllipsis) {
        s += 2;
      }
      return s;
    },
  },
};
</script>
